import { Box, Container, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { banners } from "./utils";
import { CtaButton } from "./CtaButton";
import { theme } from "@/theme";

export function HomeBanner() {
  return (
    <Box
      sx={{
        backgroundColor: "#e1f3ff",
        height: { xs: 580, sm: 660, md: 600 },
        overflow: "hidden",
        backgroundImage: "url(/background_overlay.png)",
        backgroundSize: "cover",
        position: "relative",

        "& .swiper-pagination-bullet": {
          backgroundColor: "rgba(255, 255, 255, 0.4)",
          width: 8,
          height: 8,
          opacity: 1,
        },
        "& .swiper-pagination-bullet-active": {
          backgroundColor: theme.palette.common.white,
          width: 10,
          height: 10,
          boxShadow: `0 0 0 2px ${theme.palette.common.white}`,
        },
      }}
    >
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        style={{ height: "100%" }}
      >
        {banners.map((banner, index) => (
          <SwiperSlide key={index}>
            <Container
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "space-between",
                alignItems: "center",
                gap: { xs: 3, md: 0 },
                position: "relative",
                height: "100%",
                paddingTop: { xs: 8, md: 0 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: { xs: 1, md: 3 },
                  textAlign: { xs: "center", md: "left" },
                  maxWidth: { md: 590, lg: 726 },

                  justifyContent: { md: "center" },
                  height: { md: "100%" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: 22, sm: 32, md: 38, lg: 48 },
                    fontWeight: "bold",
                    color: theme.palette.common.white,
                    lineHeight: 1.2,
                  }}
                >
                  {banner.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: 14, sm: 16, md: 18 },
                    color: theme.palette.common.white,
                  }}
                >
                  {banner.subtitle}
                </Typography>

                <Box>
                  <CtaButton href={banner.ctaLink}>{banner.ctaText}</CtaButton>
                </Box>
              </Box>

              <Box
                sx={{
                  maxWidth: { xs: 250, sm: 300, md: 365, lg: 435 },
                  width: "100%",
                  height: "auto",
                  position: "absolute",
                  bottom: 0,
                  right: { md: 0 },
                  lineHeight: 0,
                  transform: { xs: "translateX(-50%)", md: "none" },
                  left: { xs: "50%", md: "auto" },
                }}
              >
                <img src={banner.image} style={{ width: "100%", height: "auto" }} />
              </Box>
            </Container>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}
